<div class="loading-indicator">
  <dxc-spinner
    margin="medium"
    label="{{ 'label.common.loading' | translate }}"
    mode="large"
  ></dxc-spinner>
</div>
